import {
    type ApprovalSettings,
    type ApprovalSettingsPatch,
    UNAVAILABLE_APPROVAL_SETTINGS,
} from '@apps/web/features/phoebe_chat_v3/model/approval_rules';

/**
 * What a chat needs to change the approval settings, declared here and
 * supplied by `useAgentApprovalSettings`.
 *
 * The feature cannot import that hook: it reaches other features through the
 * settings cache, which `import_boundary.test.ts` forbids. So the contract
 * lives with the consumer and the owner of the request implements it, which
 * also keeps writing out of the data module.
 */
export type ApprovalSettingsWriter = Readonly<{
    readonly saving: boolean;
    readonly save: (patch: ApprovalSettingsPatch) => Promise<boolean>;
    readonly saveRules: (text: string) => Promise<boolean>;
}>;

export type WritableApprovalSettings = ApprovalSettings &
    ApprovalSettingsWriter;

export const UNAVAILABLE_WRITABLE_APPROVAL_SETTINGS: WritableApprovalSettings =
    {
        ...UNAVAILABLE_APPROVAL_SETTINGS,
        saving: false,
        save: async () => false,
        saveRules: async () => false,
    };
